<template>
    <svg
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M18 3.75V12.75C18 14.6484 16.4883 16.125 14.625 16.125H12.0938C11.6016 16.125 11.25 15.7734 11.25 15.2812C11.25 14.8242 11.6016 14.4375 12.0938 14.4375H14.625C15.5391 14.4375 16.3125 13.6992 16.3125 12.75V3.75C16.3125 2.83594 15.5391 2.0625 14.625 2.0625H12.0938C11.6016 2.0625 11.25 1.71094 11.25 1.21875C11.25 0.761719 11.6016 0.375 12.0938 0.375H14.625C16.4883 0.375 18 1.88672 18 3.75ZM12.1289 7.6875C12.4453 8.00391 12.4453 8.53125 12.1289 8.84766L7.62891 13.6289C7.45312 13.8047 7.24219 13.875 7.03125 13.875C6.82031 13.875 6.60938 13.8047 6.43359 13.6641C6.08203 13.3477 6.08203 12.8203 6.39844 12.4688L9.5625 9.09375H0.84375C0.351562 9.09375 0 8.74219 0 8.25C0 7.79297 0.351562 7.40625 0.84375 7.40625H9.5625L6.39844 4.06641C6.08203 3.71484 6.08203 3.1875 6.43359 2.87109C6.78516 2.55469 7.3125 2.55469 7.62891 2.90625L12.1289 7.6875Z"
            fill="inherit"
        />
    </svg>
</template>
